import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { getFrameAfterRotate } from '../../../../../../../../slide/infrastructure/module/independent/graphic';
import styles from './anim-tips-wrapper.css';
import { transaction } from 'mobx';
import { CANVAS_PT_SCALE } from '../../../../../../../../slide/infrastructure/module/independent/unit';
import ObserverFactory from '@src/slide/application/service/modelObserver/observerFactory';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { AnimEventType } from '@src/slide/domain/ui-model/element-modeles/property/animation/constants';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import EditingStateManager from '@src/slide/application/service/editing-state-manager';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

const PT = 48;
const TOP_PT = 36;
const LEFT_PT = 34;
const FONT_HEIGHT_PT = 38;
const FONT_SIZE_PT = 28;

interface Props {
    element: IElementBaseModel;
    scale: number;
    editingStateManager: EditingStateManager;
}

@observer
class AnimTipsWrapper extends Component<Props> {
    public componentDidMount() {
        const { element } = this.props;
        const observer = ObserverFactory.createObserver(element);
        if (observer) {
            observer.addChangesetObserver(this.updateComponent);
        }
    }

    public componentWillUnmount() {
        const { element } = this.props;
        const observer = ObserverFactory.createObserver(element);
        if (observer) {
            observer.removeChangesetObserver(this.updateComponent);
        }
    }
    public render() {
        const { element } = this.props;
        if (!element.animList[0]) {
            return;
        }
        let rect = {
            ...element.props.style,
        };

        // 元素有旋转角度时，tips的rect需要动态算
        if (element.props.style.rotate !== 0) {
            rect = getFrameAfterRotate(rect, element.props.style.rotate);
        }

        const lineHeight = this.realScale(28) * CANVAS_PT_SCALE;
        const line = Math.floor((rect.height + (this.realScale(10) * CANVAS_PT_SCALE)) / lineHeight);

        let lastAnim = { ...element.animList[0] };
        let lastIndex = 0;
        const spiltArray: any[] = [];
        spiltArray.push([element.animList[0]]);

        // 一个元素有多个动画时， 要动态显示多个tips， 这里还需要处理显示不下的动态排版
        for (let i = 1; i < element.animList.length; i++) {
            if (lastAnim.order === element.animList[i].order) {
                spiltArray[lastIndex].push(element.animList[i]);
            } else if (line === lastIndex + 1) {
                spiltArray[lastIndex].push(element.animList[i]);
            } else {
                spiltArray.push([element.animList[i]]);
                lastIndex += 1;
            }
            lastAnim = element.animList[i];
        }

        return (
            <React.Fragment>
                {
                    this.isShowTips()
                    && spiltArray.map(this.renderTips)
                }
            </React.Fragment>
        );
    }

    private updateComponent = () => {
        this.setState({});
    };

    /**
     * 点击动画tips时，清掉元素选中态，同时更新tips选中态和动画选中态
     * @param {*} event 点击事件
     * @param {*} anims 点击动画
     */
    private handleClick = (event: React.MouseEvent, anims: any) => {
        this.getSelectionService()?.selectedElements.clear();
        event.stopPropagation();
        event.preventDefault();
        transaction(() => {
            // shift/control/command按住时多选
            if (event.metaKey || event.shiftKey || event.ctrlKey) {
                for (let i = 0; i < anims.length; i++) {
                    this.getAppServices().editableServiceLayer?.selectedAnims.add(anims[i]);
                }
            } else {
                if (anims.length === 1) {
                    //  按道理讲，点击动画角标切换，selectedAnims.clear()及add会触发对selectedAnims的reaction，
                    // 但是并未触发，只能通过派发事件进行
                    this.getAnimationEditorService()?.promise()
                        .then((service) => {
                            service?.events.emit(AnimEventType.MODIFY_ANIM_TYPE, { animType: anims[0].props.animType });
                            service?.updateModel({ unfoldItemKey: anims[0].key });
                        });
                }
                this.getAppServices().editableServiceLayer?.selectedAnims.clear();
                for (let i = 0; i < anims.length; i++) {
                    this.getAppServices().editableServiceLayer?.selectedAnims.add(anims[i]);
                }
            }
            // 动画窗格滚到最后一个动画
            const array = this.getAppServices().editableServiceLayer?.selectedAnims.selectedArray;
            if (array) {
                const lastModel = array[array.length - 1];
                lastModel.needScroll = true;
            }
        });
    };

    private stopPropagation = (event) => {
        event.stopPropagation();
        event.preventDefault();
    };

    // 根据当前slide的缩放比例调整tips的显示比例
    private realScale = (pt: number): number => (pt / (this.props.scale * CANVAS_PT_SCALE));

    private getCircleClass = (selected: boolean): string => (selected ? styles.circleSelectedNew : styles.circleNew);

    private getCircleStyle = (selected: boolean): object => (selected ? {
        boxShadow: 'none',
    } : {
        border: `solid ${this.realScale(2)}px var(--border-ultrastrong)`,
    });

    private getTextStyle = (selected: boolean): object => (selected ? {
        color: 'var(--text-white)',
    } : {
        color: 'var(--text-medium)',
    });

    private renderOneTips = (rect: any, selected: boolean, array: any, index: number) => {
        const anim = { ...array[0] };
        const { order } = anim;
        return (
            <div className={this.getCircleClass(selected)}
                style={{
                    top: `${rect.top + (index * this.realScale(TOP_PT) * CANVAS_PT_SCALE)}px`,
                    left: `${rect.left - (this.realScale(LEFT_PT) * CANVAS_PT_SCALE)}px`,
                    width: `${this.realScale(PT)}px`,
                    height: `${this.realScale(PT)}px`,
                    borderRadius: `${this.realScale(PT / 2)}px`,
                    pointerEvents: 'auto',
                    ...this.getCircleStyle(selected),
                }}
                onMouseDown={(e) => {
                    this.handleClick(e, array);
                }}
                onContextMenu={this.stopPropagation}
                key={anim.key}
            >
                <div className={selected ? styles.textSelected : styles.text}
                    style={{
                        width: `${this.realScale(FONT_HEIGHT_PT)}px`,
                        height: `${this.realScale(FONT_HEIGHT_PT)}px`,
                        fontSize: `${this.realScale(FONT_SIZE_PT)}px`,
                        ...this.getTextStyle(selected),
                    }}>
                    {order}
                </div>
            </div>
        );
    };

    private renderMoreTips = (rect: any, selected: boolean, array: any, index: number) => {
        const anim = { ...array[0] };
        return (
            <React.Fragment key={anim.key}>
                <div className={this.getCircleClass(selected)}
                    style={{
                        top: `${rect.top + (index * this.realScale(TOP_PT) * CANVAS_PT_SCALE) + (this.realScale(2) * CANVAS_PT_SCALE)}px`,
                        left: `${rect.left - (this.realScale(LEFT_PT) * CANVAS_PT_SCALE) + (this.realScale(2) * CANVAS_PT_SCALE)}px`,
                        width: `${this.realScale(PT)}px`,
                        height: `${this.realScale(PT)}px`,
                        borderRadius: `${this.realScale(PT / 2)}px`,
                        pointerEvents: 'auto',
                        ...this.getCircleStyle(selected),
                    }}
                    onMouseDown={(e) => {
                        this.handleClick(e, array);
                    }}
                    onContextMenu={this.stopPropagation}
                >
                </div>
                {this.renderOneTips(rect, selected, array, index)}
            </React.Fragment>
        );
    };

    private renderTips = (array: any, index: number) => {
        let selected = false;
        for (let i = 0; i < array.length; i++) {
            if (array[i].selected) {
                selected = true;
                break;
            }
        }

        const { element } = this.props;
        let rect = {
            ...element.props.style,
        };

        // 元素有旋转角度时，tips的rect需要动态算
        if (element.props.style.rotate !== 0) {
            rect = getFrameAfterRotate(rect, element.props.style.rotate);
        }

        if (array.length > 1) {
            return this.renderMoreTips(rect, selected, array, index);
        }
        if (array.length === 1) {
            return this.renderOneTips(rect, selected, array, index);
        }
        return null;
    };

    private isShowTips(): boolean {
        const isInAnyEditingState = this.props.editingStateManager.isInAnyEditingState();
        const isAnimPreviewing = this.getAppServices().viewableServiceLayer?.editorAnimPreviewManager?.isAnimPreviewing;
        return !isInAnyEditingState && !isAnimPreviewing
            && !this.props.element.hidden;
    }

    private getAnimationEditorService(): any {
        return this.getAppServices().editableServiceLayer?.animationEditorService;
    }

    private getSelectionService(): any {
        return this.getAppServices().viewableServiceLayer?.selectionService;
    }

    private getAppServices(): any {
        return AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
    }
}

export default AnimTipsWrapper;
